const InfoRow = ({ label, value, ...rest }) => {
  if (value) {
    return (
      <div className='info-row'>
        <div className='label'>{label}</div>
        <div className='value' {...rest}>
          {value}
        </div>
      </div>
    )
  }
  return null
}

export default InfoRow
